import "./footer-style.scss";
import { SocialDock } from "../components/ui/SocialDock";
import { useLanguage } from "../hooks/useLanguage";
import PHONE_ICON from "../images/phone.webp";
import EMAIL_ICON from "../images/email.webp";
import LOCATION_ICON from "../images/location.webp";
import PORFOLIO_ICON from "../images/portfolio-logo.webp";

export function Footer() {
  const { translations: t } = useLanguage();
  const FOOTER = t.footer[0]; // Access the first object directly

  return (
    <footer className="footer_container">
      <div className="footer_content_wrapper">
        <div className="brand_column">
          <div className="logo_wrapper">
            <img src={PORFOLIO_ICON} alt="Jonathan Cocuy" className="brand_logo" />
            <span className="brand_name">Jonathan Cocuy</span>
          </div>
          <p className="brand_phrase">{FOOTER.phrase}</p>
        </div>

        <div className="contact_column">
          <h3 className="column_title">{FOOTER.contact.title}</h3>
          <ul className="contact_list">
            <li className="contact_item">
              <img src={PHONE_ICON} alt="Phone" className="contact_icon" />
              <span>{FOOTER.contact.phone_number}</span>
            </li>
            <li className="contact_item">
              <img src={EMAIL_ICON} alt="Email" className="contact_icon" />
              <span>{FOOTER.contact.email}</span>
            </li>
            <li className="contact_item">
              <img src={LOCATION_ICON} alt="Location" className="contact_icon" />
              <span>{FOOTER.contact.location}</span>
            </li>
          </ul>
        </div>

        <div className="social_column">
          <h3 className="column_title">{FOOTER.follow}</h3>
          <div className="social_icons_wrapper">
            <SocialDock />
          </div>
        </div>
      </div>

      <div className="copyright_bar">
        <p className="copyright_text">
          &copy; {new Date().getFullYear()} {FOOTER.description}
        </p>
      </div>
    </footer>
  );
}
